module.exports = __webpack_public_path__ + "static/media/Element_Hydro.407d4441.png";